<ng-container *ngIf="isAthenaEMR$ | async">
  <mat-card class="athena-patient-configuration">
    <mat-card-header>
      <mat-card-title>Athena Patient Configuration</mat-card-title>
      <mat-card-subtitle> Add extra information to the patient's record from Athena. </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="athena-patient-configuration__section">
        <h3>Rendering provider</h3>
        <p class="athena-patient-configuration__description">
          Search for the rendering provider in Athena to add it to the patient's record. Select the provider from the
          list and click save.
        </p>
        <form [formGroup]="providerForm">
          <div class="athena_form__row search-container">
            <mat-form-field class="athena_form__field">
              <mat-label>Last name</mat-label>
              <input matInput formControlName="last_name" />
            </mat-form-field>
            <button
              mat-icon-button
              (click)="searchAthenaClinicalProvider()"
              [disabled]="isSearching || providerForm?.invalid"
              matTooltip="Search rendering provider in Athena"
              class="search-button"
            >
              <mat-icon>search</mat-icon>
            </button>
          </div>
          <mat-error *ngIf="providerForm?.get('last_name')?.hasError('required')">Last name is required</mat-error>
        </form>
        <mat-progress-bar *ngIf="isSearching" class="search-progress" mode="indeterminate"></mat-progress-bar>
        <div class="search-results" *ngIf="athenaClinicalProviders && !isSearching">
          <h4>Choose a rendering provider from the list</h4>
          <mat-selection-list *ngIf="athenaClinicalProviders.length" [multiple]="false" class="athena_form__selection-list" (selectionChange)="onProviderSelectionChange($event)">
            <mat-list-option
              *ngFor="let provider of athenaClinicalProviders"
              [value]="provider"
            >
              {{ provider.firstname }} {{ provider.lastname }} (ProviderID: {{ provider.providerid }})
            </mat-list-option>
          </mat-selection-list>
          <p *ngIf="!athenaClinicalProviders.length" class="no-providers-message">No providers found</p>
        </div>
        <div *ngIf="providerForm?.get('renderProviderId').value != null && providerForm?.get('renderProviderId').value !== ''">
          Selected provider: {{ providerForm?.get('renderProviderName').value }} (ProviderID:
          {{ providerForm.get('renderProviderId').value }})
        </div>
        <div fxLayout="row" fxLayoutAlign="flex-end">
          <button
            mat-raised-button
            color="primary"
            (click)="saveAthenaClientProvider()"
            [disabled]="isSaveDisabled"
          >
            <mat-spinner *ngIf="isSaving" [diameter]="20"></mat-spinner>
            <span *ngIf="!isSaving">Save</span>
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
